import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ConstantsService {
	prefix: string;
	isPositiveTheme: boolean;

	constructor() {
		this.prefix = '';
	}

	getPrefix(): string {
		return this.prefix;
	}

	getIsPositiveTheme(): boolean {
		return this.isPositiveTheme;
	}

	setIsPositiveTheme(isPositive: boolean): void {
		this.isPositiveTheme = isPositive;
	}
}
